import React from 'react'
import {
  FooterContainer,
  FooterGrid,
  Column,
  LogoImg,
  TrackButton,
  ColumnTitle,
  AvisoText,
  PaymentImg,
  SecureButton
} from './Footer.elements'

import { FaLock, FaShieldAlt } from 'react-icons/fa'

function Footer() {
  return (
    <FooterContainer>
      <FooterGrid>

        {/* COLUNA 1 — LOGO */}
        <Column>
          <LogoImg src={require('../../images/logo_vitafaz.png')} alt="Vitafaz Suplementos" />
        </Column>

        {/* COLUNA 2 — RASTREIO */}
        <Column>
          <TrackButton href="https://rastreamento.correios.com.br/app/index.php" target="_blank" rel="noopener noreferrer">
            RASTREAR PEDIDO
          </TrackButton>
        </Column>

        {/* COLUNA 3 — AVISO */}
        <Column>
          <ColumnTitle>Aviso</ColumnTitle>
          <AvisoText>
            PRÓ-FÍGADO NÃO é medicamento. Não substitui uma alimentação equilibrada e hábitos de vida saudáveis. Este produto é classificado como suplemento alimentar e está dispensado de registro sanitário, conforme a legislação vigente da ANVISA.
          </AvisoText>
        </Column>

        {/* COLUNA 4 — PAGAMENTO */}
        <Column>
          <ColumnTitle>Formas de Pagamento</ColumnTitle>
          <PaymentImg src={require('../../images/pagamento-icon.png')} alt="Formas de pagamento aceitas" />
        </Column>

        {/* COLUNA 5 — SITE SEGURO */}
        <Column>
          <ColumnTitle>Site Seguro</ColumnTitle>

          <SecureButton>
            <FaLock /> Ambiente Seguro
          </SecureButton>

          <SecureButton>
            <FaShieldAlt /> SSL Certificado
          </SecureButton>
        </Column>

      </FooterGrid>
    </FooterContainer>
  )
}

export default Footer
